import { jsx as e, jsxs as p } from "react/jsx-runtime";
import { useState as y, useEffect as C } from "react";
import { useNavigate as v, redirect as w } from "react-router-dom";
import { Snackbar as P, Slide as x, SnackbarContent as T, Stack as A, Box as k, Typography as m, Button as g, Alert as D } from "@mui/material";
import { _ as I, l as B } from "../../index-DNTqwtVt.js";
import { useSchool as N } from "../../context/school/index.js";
import { usePushNotifications as M } from "../../context/pushnotifications/index.js";
import { stripHtmlAndDecode as S } from "../../helpers/strings.js";
import { NotificationType as c } from "../../helpers/daymaptypes.js";
const F = ({ getNotificationUrl: n }) => {
  const { schoolCode: t } = N(), { pushNotifications: l, actionedNotification: a, setPushNotifications: i } = M(), [d, h] = y([]), u = v();
  C(() => {
    if (a)
      if (a.SchoolCode !== t)
        i([...l, a]);
      else {
        const o = n(a);
        o && u(o);
      }
  }, [a]);
  const f = (o, s) => s !== "clickaway" && h([...d, o.NotificationID]), r = (o) => {
    h([...d, o.NotificationID]);
    const s = n(o);
    s && w(s);
  };
  return l.map((o) => /* @__PURE__ */ e(
    V,
    {
      open: d.indexOf(o.NotificationID) === -1,
      notification: o,
      onClose: (s) => f(o, s),
      onActionButtonClick: () => r(o),
      getNotificationUrl: n
    },
    o.NotificationID
  ));
}, V = ({ open: n, notification: t, onClose: l, onActionButtonClick: a, getNotificationUrl: i }) => {
  const { iconType: d } = I(t.NotificationType), { schoolCode: h, schoolList: u, UpdateSchool: f } = N();
  let r;
  if (h !== t.SchoolCode && (r = u.find((s) => s.schoolCode === t.SchoolCode), !r))
    return null;
  const o = () => {
    r && f(r);
  };
  return /* @__PURE__ */ e(
    P,
    {
      open: n,
      autoHideDuration: r ? void 0 : 5e3,
      onClose: (s, b) => l(b),
      anchorOrigin: { vertical: "top", horizontal: "center" },
      slots: { transition: x },
      children: /* @__PURE__ */ e(
        T,
        {
          sx: {
            bgcolor: "var(--mui-palette-background-paper)",
            color: "var(--mui-palette-text-primary)",
            backgroundImage: "var(--Paper-overlay)"
          },
          message: /* @__PURE__ */ p(A, { spacing: 1, children: [
            /* @__PURE__ */ p(k, { display: "flex", gap: 1, children: [
              /* @__PURE__ */ e(B, { iconType: d }),
              /* @__PURE__ */ e(m, { fontWeight: 600, children: S(t.Title) })
            ] }),
            /* @__PURE__ */ e(m, { children: S(t.Message) }),
            /* @__PURE__ */ p(k, { display: "flex", gap: 1, children: [
              !r && /* @__PURE__ */ e(j, { notification: t, onClick: a, getNotificationUrl: i }),
              /* @__PURE__ */ e(g, { onClick: () => l(), children: "Dismiss" })
            ] }),
            r && /* @__PURE__ */ e(D, { severity: "info", action: /* @__PURE__ */ e(g, { color: "inherit", size: "small", onClick: o, children: "Swap School" }), children: /* @__PURE__ */ p(m, { children: [
              "This notification is not for the school you are currently logged in to. Swap to ",
              r.schoolName,
              "?"
            ] }) })
          ] })
        }
      )
    }
  );
};
function j({ notification: n, onClick: t, getNotificationUrl: l }) {
  if (l(n)) {
    let i = "";
    switch (n.NotificationType) {
      case c.PointsAdded:
        i = "View points";
        break;
      case c.PeerToPeerMessage:
        i = "View message";
        break;
      case c.UnapprovedAbsence:
        i = "Message school";
        break;
      case c.Excursion:
        i = "View excursion";
        break;
      case c.ParentTeacherInterview:
        i = "Manage interviews";
        break;
      case c.AssessmentPublished:
      case c.NewRecord:
      case c.RecordComment:
      case c.None:
      default:
        return null;
    }
    return /* @__PURE__ */ e(g, { onClick: t, children: i });
  }
  return null;
}
export {
  F as PushNotificationSnackbars
};
//# sourceMappingURL=index.js.map
